export const UPDATE_DRIVER_LIST = "UPDATE_DRIVER_LIST"


/**
 *
 *
 * @param drivers
 * @returns {{type: *, drivers: *}}
 */
export const updateDriverList = (drivers) => ({
  type: UPDATE_DRIVER_LIST,
  drivers
})
